import styled from "styled-components";
import { device } from "../hooks/device";
import whiteCheck from "../img/white_ch.svg";
import TextLine from "../atomic/atom/TextLine";
import { useTranslation } from "react-i18next";
import DivTwoPartImprove from "../atomic/atom/DivTwoPartImprove";

const Terms = ({
  checkBox1,
  setCheckBox1,
  checkBox2,
  setCheckBox2,
  checkBox3,
  setCheckBox3,
  checkBox4,
  setCheckBox4,
  checkBox5,
  setCheckBox5,
}) => {
  const onChangeSetCheckBox = (e, setFc) => {
    setFc(e.target.checked);
  };
  const { t } = useTranslation();
  const baseLang = "login.e1_1";

  return (
    <>
      <StTerms>
        <TextLine
          text={t(`${baseLang}.menus.policy.title`)}
          fontsize={13}
          pc_fontsize={15}
          fontFamily="medium"
          pc_margin="0 0 10px 0"
          padding="14px 0 5px"
          pc_padding="0"
        />
        <StCheckbox whiteCheck={whiteCheck}>
          <div className="checkBoxList">
            <div className="checkList">
              <input
                type="checkbox"
                id="checkbox1"
                onChange={(e) => onChangeSetCheckBox(e, setCheckBox1)}
                checked={checkBox1}
              />
              {/* <div htmlFor="checkbox1">여기야</div> */}
              <label htmlFor="checkbox1" />
              <p>{t(`${baseLang}.menus.policy.check.one`)}</p>
            </div>
            <div className="checkList">
              <input
                type="checkbox"
                id="checkbox2"
                onChange={(e) => onChangeSetCheckBox(e, setCheckBox2)}
                checked={checkBox2}
              />
              <label htmlFor="checkbox2" />
              <p>
                {t(`${baseLang}.menus.policy.check.agree`)}
                <span
                  className="detailBtn"
                  onClick={() => {
                    window.open(
                      `https://edint.notion.site/Terms-of-Service-763a795a12fe43d6905ccfd74bf9d7cd`
                    );
                  }}
                >
                  {t(`${baseLang}.menus.policy.check.two`)}
                </span>{" "}
              </p>
            </div>
            {/* <div className="checkList">
              <input
                type="checkbox"
                id="checkbox5"
                onChange={(e) => onChangeSetCheckBox(e, setCheckBox3)}
                checked={checkBox3}
              />
              <label htmlFor="checkbox5" />
              <DivTwoPartImprove
                margin="0 0 15px 12px"
                font_size={15}
                lineheight={22}
              >
                <TextLine text={t(`${baseLang}.menus.policy.check.agree`)} />
                <TextLine
                  text={t(`${baseLang}.menus.policy.check.three`)}
                  onclick={() => {
                    window.open(
                      `https://edint.notion.site/45222e54e558415487d672680ef1a310?pvs=4`
                    );
                  }}
                  margin="0 0 0 4px"
                  fontcolor="#2276DC"
                  textdeco="underline"
                />
              </DivTwoPartImprove>
            </div> */}
            <div className="checkList">
              <input
                type="checkbox"
                id="checkbox3"
                onChange={(e) => onChangeSetCheckBox(e, setCheckBox4)}
                checked={checkBox4}
              />
              <label htmlFor="checkbox3" />
              <p>
                {t(`${baseLang}.menus.policy.check.agree`)}
                <span
                  className="detailBtn"
                  onClick={() => {
                    window.open(
                      `https://edint.notion.site/Privacy-Policy-6a6debbfaa5a4b7c83d7326c9a082dd1`
                    );
                  }}
                >
                  {t(`${baseLang}.menus.policy.check.four`)}
                </span>{" "}
              </p>
            </div>
            {setCheckBox5 && (
              <div className="checkList">
                <input
                  type="checkbox"
                  id="checkbox4"
                  onChange={(e) => onChangeSetCheckBox(e, setCheckBox5)}
                  checked={checkBox5}
                />
                <label htmlFor="checkbox4" />
                <p>{t(`${baseLang}.menus.policy.check.five`)}</p>
              </div>
            )}
          </div>
        </StCheckbox>
      </StTerms>
    </>
  );
};

const StTerms = styled.section`
  display: grid;
  .checkBoxList {
    padding-top: 5px;
  }

  .checkList {
    display: flex;

    :not(:last-child) {
      margin-bottom: 15px;
    }

    p {
      font-family: "Regular";
      font-size: 15px;
      line-height: 22px;
    }
  }

  @media ${device.tablet} {
    .mainDescription {
      font-size: 16px;
      line-height: 24px;
      font-family: "Regular";
      margin: 10px 0 16px;
    }
    .description {
      color: #6e6e6e;
      font-size: 11px;
      line-height: 16px;
    }
  }

  @media ${device.mobile} {
    .mainDescription {
      font-family: "Regular";
      font-size: 16px;
      line-height: 24px;
      margin: 10px 0 16px;
    }
    .description {
      color: #6e6e6e;
      font-size: 11px;
      line-height: 16px;
    }
  }
`;

const StCheckbox = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  p {
    padding: 0 0 0 12px;
    margin: 0;
    font-family: "light";
    span {
      display: inline-block;
      cursor: pointer;
      color: #2276dc;
      text-decoration: underline;
      text-underline-position: under;
    }
  }

  input[type="checkbox"] {
    display: none;
  }

  input[type="checkbox"] + label:before {
    //체크 안된 상태의 라벨
    content: "";
    display: flex;
    width: 22px;
    height: 22px;
    border: 0.6px solid #818181;
    border-radius: 4px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
  }
  input[type="checkbox"]:checked + label:before {
    //체크된 상태의 라벨
    content: "";
    display: flex;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 4px;
    background-color: #20315b;
    background-image: url(${(props) => props.whiteCheck});
    background-repeat: no-repeat;
    background-position: center;
  }

  @media ${device.tablet} {
    font-size: 14px;
    line-height: 21px;
    padding-top: 5px;
    margin-bottom: 14px;
    p {
      span {
        height: 18px;
        line-height: 21px;
      }
    }
  }

  @media ${device.mobile} {
    font-size: 14px;
    line-height: 21px;
    padding-top: 5px;
    margin-bottom: 14px;

    p {
      span {
        height: 18px;
        line-height: 21px;
      }
    }
  }
`;

const TermsDetail = styled.section`
  @media ${device.pc} {
  }
  @media (max-width: 1139px) {
    .bodys {
      margin: 0 auto !important;
      left: 0 !important;
      transform: translate(0%, 0%) !important;
      .bodyHead {
        font-size: 22px !important;
      }
      .contents {
        padding: 0 !important;
      }
    }
  }
`;

export default Terms;
